import { ThemeProvider } from '@mui/material';
import { MuiTheme } from '../components/Theme/theme';
import { ReactNode } from 'react';

type ProvidersProps = {
  children: ReactNode;
};

const Providers: React.FC<ProvidersProps> = (props) => {
  const { children } = props;
  return <ThemeProvider theme={MuiTheme}>{children}</ThemeProvider>;
};

export default Providers;
